
import React from 'react';
import { DateRange } from 'react-day-picker';
import { DateRangeFilter } from './DateRangeFilter';

interface AnalyticsHeaderProps {
  dateRange: DateRange;
  setDateRange: (dateRange: DateRange) => void;
}

const AnalyticsHeader = ({ dateRange, setDateRange }: AnalyticsHeaderProps) => (
  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Analytics Dashboard</h1>
      <p className="text-gray-600 mt-1">Monitor your platform's real performance vs display metrics</p>
    </div>
    <DateRangeFilter dateRange={dateRange} setDateRange={setDateRange} />
  </div>
);

export default AnalyticsHeader;
